

<template>
  <!-- #ifdef H5 -->
	<div class="mask">
		<div class="container">
			<text class="title">复制内容</text>
			<text class="content">{{content}}</text>
			<view class="button" @click.stop="copy">一键复制</view>
		</div>
	</div>

  <!-- #endif -->
</template>

<script>
	import {
		copyText
	} from '../utils'
	export default {
		name: 'Dialog',
		data() {
			return {
				isVisible: false,
				code: ''
			}
		},
		props: {
			content: {
				type: String,
				default: () => '',
			}
		},
		methods: {
			copy() {
				console.log(this.content)
				const result = copyText(this.content)
				this.onCopy(result)
			}
		}
	}

</script>

<style scoped>

	.mask {
		position: absolute;
		z-index: 1100;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;

		background: rgba(0, 0, 0, 0.6);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.container {
		background: white;
		padding: 20px 20px 20px 20px;
		border-radius: 12px;
		max-width: 280px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.title {
		color: #FF4242;
		font-weight: bold;
		font-size: 18px;
	}

	.content {
		margin-top: 6px;
		color: #333333;
		font-size: 14px;
	}

	.button {
		color: white;
		font-size: 14px;
		background: linear-gradient(270deg, #FF4379 0%, #FF4242 100%);
		border-radius: 8px;
		height: 40px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 25px;

	}

</style>

